import { render, staticRenderFns } from "./MatQuestions.vue?vue&type=template&id=616a7ef0&scoped=true"
import script from "./MatQuestions.vue?vue&type=script&lang=js"
export * from "./MatQuestions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "616a7ef0",
  null
  
)

export default component.exports